import { Link } from 'react-router';
import { Cartao } from '../componentes/ui';

/** Página inicial provisória. O painel da equipe (fila, ficha, aprovação) entra na fase 1. */
export function Inicio() {
  return (
    <main className="mx-auto max-w-xl p-4 sm:p-8">
      <Cartao>
        <h1 className="text-xl font-semibold">Contefy · Aberturas</h1>
        <p className="mt-2 text-slate-600">
          Este endereço serve a página do cliente, acessada pelo link único enviado no WhatsApp (
          <code className="rounded bg-slate-100 px-1">/c/&lt;código&gt;</code>). O painel da equipe
          está em construção.
        </p>
        <p className="mt-4 text-sm text-slate-500">
          Em desenvolvimento, rode <code className="rounded bg-slate-100 px-1">pnpm db:seed</code>{' '}
          para gerar um link de exemplo, ou dispare o webhook do formulário.
        </p>
        <Link to="/equipe" className="mt-4 inline-block text-marca-700 underline">
          Painel da equipe
        </Link>
      </Cartao>
    </main>
  );
}
